require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-quick-intro-to-gulp-js.json") })
        }
      }, "path---blog-quick-intro-to-gulp-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-quick-intro-to-gulp-js!./.cache/json/blog-quick-intro-to-gulp-js.json
// module id = 1050
// module chunks = 231608221292675